import ProjectCard from "./ProjectCard";
import {projects as defaultProjects, ProjectProps} from "./projectDetails";
import React from "react";

type ProjectGridProps = {
    projects?: ProjectProps[];
};

const ProjectGrid = ({projects = defaultProjects}: ProjectGridProps) => {
    return (
        <>
            <div className="mb-10 flex gap-16 text-[#e4ded7] md:mb-16  lg:mb-20 ">
                <h4
                    className={`text-[16px] md:text-[20px] lg:text-[34px] ${"text-[#e4ded7]"}`}
                >
                    Mes réalisations
                </h4>
            </div>

            <div className="grid w-[90%] grid-cols-1 gap-y-6 gap-x-6 md:gap-y-8 lg:max-w-[1200px] lg:grid-cols-1 lg:gap-y-10">
                {projects.map((project: ProjectProps) => (
                    <ProjectCard
                        id={project.id}
                        key={project.id}
                        name={project.name}
                        description={project.description}
                        technologies={project.technologies}
                        techNames={project.techNames}
                        techLinks={project.techLinks}
                        github={project.github}
                        demo={project.demo}
                        image={project.image}
                        available={project.available}
                    />
                ))}
            </div>
        </>
    );
};

export default ProjectGrid;
